// Livro do card "como funciona" da home (.cda-how__book).
//
// Inclina o livro na direção do cursor: a posição do mouse sobre o livro vira as
// variáveis --cda-book-rx / --cda-book-ry lidas pelo transform em home_how.scss,
// e a faixa de brilho da capa corre junto (--cda-book-glare).
// Ao sair, zera as variáveis e o CSS devolve o livro para reto.

var MAX_TILT = 26; // graus

function bindBook(book) {
  if (book.getAttribute('data-cda-tilt-bound') === '1') return;
  book.setAttribute('data-cda-tilt-bound', '1');

  var cover = book.querySelector('.cda-how__book-cover');
  if (!cover) return;

  book.addEventListener('pointermove', function(event) {
    if (event.pointerType === 'touch') return;
    var rect = cover.getBoundingClientRect();
    var x = (event.clientX - rect.left) / rect.width - 0.5;  // -0.5 (esquerda) .. 0.5 (direita)
    var y = (event.clientY - rect.top) / rect.height - 0.5;  // -0.5 (topo) .. 0.5 (base)
    x = Math.max(-0.5, Math.min(0.5, x));
    y = Math.max(-0.5, Math.min(0.5, y));

    book.classList.add('is-tilting');
    // o lado onde está o cursor afunda, como se o dedo empurrasse a capa
    cover.style.setProperty('--cda-book-ry', (x * 2 * MAX_TILT).toFixed(2) + 'deg');
    cover.style.setProperty('--cda-book-rx', (-y * 2 * MAX_TILT * 0.7).toFixed(2) + 'deg');
    // faixa de brilho: 100% fica na borda esquerda, 0% na direita
    cover.style.setProperty('--cda-book-glare', ((0.5 - x) * 100).toFixed(1) + '%');
    // ponto de luz segue o cursor; o sombreado cai no lado que afunda
    cover.style.setProperty('--cda-book-gx', ((x + 0.5) * 100).toFixed(1) + '%');
    cover.style.setProperty('--cda-book-gy', ((y + 0.5) * 100).toFixed(1) + '%');
    cover.style.setProperty('--cda-book-shade-angle', (Math.atan2(y, x) * 180 / Math.PI + 90).toFixed(1) + 'deg');
    book.style.setProperty('--cda-book-shadow-x', (-x * 20).toFixed(1) + 'px');
  });

  book.addEventListener('pointerleave', function() {
    book.classList.remove('is-tilting');
    cover.style.removeProperty('--cda-book-ry');
    cover.style.removeProperty('--cda-book-rx');
    cover.style.removeProperty('--cda-book-glare');
    book.style.removeProperty('--cda-book-shadow-x');
    // ponto de luz e sombreado ficam onde estavam: só apagam (opacity) no CSS
  });
}

document.addEventListener('turbolinks:load', function() {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  Array.prototype.forEach.call(document.querySelectorAll('.cda-how__book'), bindBook);
});

// Botões do topo que levam a outra seção da home (#publish, #ia-services): rolagem suave
// até ela. O scroll-margin-top da seção desconta o header grudado. Sem JS, a âncora
// funciona normalmente.
document.addEventListener('click', function(event) {
  var link = event.target.closest && event.target.closest('a[data-cda-scroll]');
  if (!link) return;
  var target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  event.preventDefault();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
});
